import script from "./WebinarCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarCard.vue?vue&type=script&setup=true&lang=js"

import "./WebinarCard.vue?vue&type=style&index=0&id=09b9a70f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b9a70f"]])

export default __exports__